import application_settings from '../applicationSettings';
import LocalStorage from '../local_data';
import Event from './Event';

class GetAbandonedCart extends Event {
    eventName = 'oms_abandonedCart';

    constructor() {
        super();
        this.add();
    }

    /**
     * @override
     * 
     * Event Function for Get Additional Charges
     * 
     * @return void
     *  
     */
    eventFunction(data) {
        let clientId = data.client_id;
        let thisObj = this;
        let requestId = (data.request_id) ? data.request_id : '';
        let action = (data.action) ? data.action : '';
        let multiCallKey = (data.multi_call_key) ? data.multi_call_key : 'abandoned_cart';
        let locationId = new LocalStorage.CurrentLocation(clientId).getData();
        let cartId = new LocalStorage.CartId(locationId).getData();
      
        data.endPoint = application_settings.endPoints.abandonedCart;
        data.multi_call_key = multiCallKey;
        data.data = {
            client_id: clientId,
            location_id: locationId,
            cart_id: cartId
        };
    
        this.sendRequest(data, function (response) {
          if (response) {
            let result = response.data;

            if (result.success) {
                result.data = (result.data) ? result.data : {};
                //add data to storage
                let cartLocation = new LocalStorage.CartLocation(locationId);
                let currentCart = cartLocation.getData();

                if (currentCart) {
                    result.data = {...result.data, ...currentCart};
                }
                cartLocation.setData(result);
            }

            //format response data
            let data = thisObj.formatResponseData(response);

            //fire success event
            thisObj.onSuccessEvent(data, {'action' : action, 'request_id' : requestId });
          }
        });
    }
}

export default GetAbandonedCart;